import { t as e } from "./cx-BjmrJCen.js";
import { i as t, n, r, t as i } from "./text.css-DDuHJ-lZ.js";
import { jsx as a } from "react/jsx-runtime";
import { forwardRef as o } from "react";
//#region src/components/text/text.tsx
function s({ as: t = "p", children: n, className: r, styleClass: i, ...o }) {
	return /* @__PURE__ */ a(t, {
		...o,
		className: e(i, r),
		children: n
	});
}
function c(e) {
	return /* @__PURE__ */ a(s, {
		...e,
		styleClass: n
	});
}
function l(e) {
	return /* @__PURE__ */ a(s, {
		...e,
		styleClass: i
	});
}
function u(e) {
	return /* @__PURE__ */ a(s, {
		...e,
		styleClass: r
	});
}
var d = o(({ className: n, ...r }, i) => /* @__PURE__ */ a("input", {
	...r,
	className: e(t, n),
	ref: i
}));
d.displayName = "VisuallyHiddenInput";
//#endregion
export { l as CopyText, u as ErrorText, c as Eyebrow, d as VisuallyHiddenInput };

//# sourceMappingURL=text.js.map